import KioskLayout from 'layouts/KioskLayout';
import Kiosk from 'pages/private/owner/Kiosk';
import KioskDetail from 'pages/private/owner/KioskDetail';
import KioskWorkout from 'pages/private/owner/KioskWorkout';
import { Navigate } from 'react-router-dom';

import { IRouteMap } from './types';

export const getKioskRouteMap = (workoutTrackerEnabled: boolean): IRouteMap => ({
  layout: KioskLayout,
  routes: [
    {
      key: 'kiosk',
      component: () => Kiosk(),
      path: '/',
    },
    {
      key: 'kioskDetail',
      component: () => KioskDetail(),
      path: '/kiosk/:eventId',
    },
    ...(workoutTrackerEnabled
      ? [
          {
            key: 'kioskWorkout' as const,
            component: () => KioskWorkout(),
            path: '/kiosk/:eventId/workout',
          },
        ]
      : []),
    {
      key: 'redirect',
      component: () => Navigate({ to: '/' }),
      path: '*',
    },
  ],
  navLinks: [],
});
